import ContactSection from "../../contact/ContactSection";
import {Box, Button} from "@mui/material";
import React, {useState} from "react";
import {useLanguage} from "../../../LanguageContext";

export const ReadyToTravelComponent = () => {
    const {t} = useLanguage();

    const [open, setOpen] = useState(false);

    return (
        <Box>
            <ContactSection open={open} setOpen={setOpen}/>
            <Box
                sx={{
                    alignContent: 'center',
                    textAlign: 'center'
                }}>
                <Button
                    onClick={() => setOpen(true)}
                    sx={{
                        background: "#29362C",
                        // mt: 4,
                        borderColor: "white",
                        borderRadius: '0',
                        color: "white",
                        zIndex: 10,
                        "&:hover": {backgroundColor: "rgba(255, 255, 255, 0.4)", color: "#29362C"},
                        width: {
                            xs: '240px',
                            sm: '240px',
                            md: '250px',
                            lg: '250px',
                        },
                        height: {
                            xs: '48px',
                            sm: '48px',
                            md: '50px',
                            lg: '50px',
                        },
                        fontSize: {
                            xs: '19px',
                            sm: '19px',
                            md: '20px',
                            lg: '20px',
                        },
                    }}
                >
                    {t('button_ready_to_travel').toUpperCase()}
                </Button>
            </Box>
        </Box>
    );
}
